// TODO: Check WebhookModel contains more events.
export default {
    customerOneTimePasswordRequested: 'customer-one-time-password-requested',
    disputeCreated: 'dispute-created',
    gatewayAccountRequested: 'gateway-account-requested',
    invoicePaid: 'invoice-paid',
    invoiceIssued: 'invoice-issued',
    invoicePastDue: 'invoice-past-due',
    invoicePastDueReminder: 'invoice-past-due-reminder',
    kycDocumentAccepted: 'kyc-document-accepted',
    kycDocumentRejected: 'kyc-document-rejected',
    nsfResponseReceived: 'nsf-response-received',
    paymentCardCreated: 'payment-card-created',
    paymentCardExpired: 'payment-card-expired',
    paymentCardExpirationReminder: 'payment-card-expiration-reminder',
    renewalInvoicePaymentDeclined: 'renewal-invoice-payment-declined',
    renewalInvoicePaymentCanceled: 'renewal-invoice-payment-canceled',
    riskScoreChanged: 'risk-score-changed',
    sanctionsListMatched: 'sanctions-list-matched',
    subscriptionActivated: 'subscription-activated',
    subscriptionCanceled: 'subscription-canceled',
    subscriptionReactivated: 'subscription-reactivated',
    subscriptionCreated: 'subscription-created',
    subscriptionEnded: 'subscription-ended',
    subscriptionRenewed: 'subscription-renewed',
    renewalInvoiceIssued: 'renewal-invoice-issued',
    subscriptionTrialEnded: 'subscription-trial-ended',
    subscriptionTrialConverted: 'subscription-trial-converted',
    subscriptionTrialEndReminder: 'subscription-trial-end-reminder',
    subscriptionRenewalReminder: 'subscription-renewal-reminder',
    transactionAmountDiscrepancyFound: 'transaction-amount-discrepancy-found',
    transactionDeclined: 'transaction-declined',
    transactionDiscrepancyFound: 'transaction-discrepancy-found',
    transactionProcessed: 'transaction-processed',
    transactionProcessRequested: 'transaction-process-requested',
};
